/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { IconButton } from "@mui/material";
import React from "react";

import MaterialSymbol from "../../../components/MaterialSymbol";

export const ExpandIcon = ({ icon, onClick }: { icon: string; onClick: () => void }) => (
  <IconButton aria-label={icon} color="primary" onClick={onClick} sx={{ p: 0 }}>
    <MaterialSymbol>{icon}</MaterialSymbol>
  </IconButton>
);
